// ============================================================================
//  scroll-reveal.js — restrained scroll-in animations (GSAP + ScrollTrigger)
//  STUB: implement next session.
//
//  Plan:
//   - Register ScrollTrigger; animate elements marked [data-reveal] with a
//     subtle fade + translateY as they enter the viewport.
//   - Stagger groups (e.g. partner cards under [data-reveal-group]).
//   - Diagram build-in for the 1N architecture section.
//   - reducedMotion: skip all animation, ensure content is fully visible.
//
//  GSAP is imported lazily to keep it out of the critical path.
// ============================================================================

export async function initScrollReveal({ reducedMotion = false } = {}) {
  const targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return; // no-op until markup exists

  if (reducedMotion) {
    targets.forEach((el) => (el.style.opacity = '1'));
    return;
  }

  const { gsap } = await import('gsap');
  const { ScrollTrigger } = await import('gsap/ScrollTrigger');
  gsap.registerPlugin(ScrollTrigger);

  targets.forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 24,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 85%', once: true },
    });
  });

  // TODO: staggered [data-reveal-group] children; diagram build-in timeline.
}
